import * as React from 'react';

import { InfrastructureFromBuilder } from '../../../components/TransportAccessibilityRate';
import { MAX_TRANSPORT_ACCESSIBILITY_RATE } from '../../../constants/transportAccessibility';
import { IInfrastructureFromBuilder } from '../../../types/transportAccessibility';
import { prepareRate } from '../helpers';

export interface IInfrastructureFromBuilderContainerProps {
  infrastructure: IInfrastructureFromBuilder;
}

export const InfrastructureFromBuilderContainer: React.VFC<IInfrastructureFromBuilderContainerProps> = ({
  infrastructure,
}) => {
  const { description, iconUrl, rate, title, rateDetails } = infrastructure;

  const displayRate = prepareRate(rate);
  const displayMaxRate = String(MAX_TRANSPORT_ACCESSIBILITY_RATE);

  return (
    <InfrastructureFromBuilder
      description={description}
      iconUrl={iconUrl}
      maxRate={displayMaxRate}
      rate={displayRate}
      title={title}
      terms={rateDetails}
    />
  );
};
